.wrap {
  position: relative;
  display: inline-block;
}

/* Кнопка-иконка одного размера с остальным рядом карточки и с проверкой цены
   (24×24, на телефоне 38×32 — см. SegmentCard.module.css). Размеры продублированы,
   а не унаследованы: карточка передаёт сюда className на обёртку, а не на саму
   кнопку, и дотянуться до неё снаружи нечем. */
.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: var(--fs-sm);
}

@media (max-width: 720px) {
  .trigger {
    width: 38px;
    height: 32px;
  }
}

.menu {
  position: absolute;
  z-index: 30;
  right: 0;
  bottom: calc(100% + var(--sp-2));
  min-width: 180px;
  max-height: 240px;
  overflow-y: auto;
  padding: var(--sp-2);
  background: var(--surface);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-rim), var(--shadow-lift);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  width: 100%;
  padding: var(--sp-3) var(--sp-3);
  background: transparent;
  border: none;
  border-radius: var(--radius);
  font-size: var(--fs-sm);
  text-align: left;
  cursor: pointer;
  color: var(--text);
}

.item:hover,
.item.active {
  background: var(--surface-2);
}

.dot {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.name {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.check {
  flex: 0 0 auto;
  color: var(--text-3);
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Карточка стоит в горизонтальной ленте библиотеки, а прокрутка по одной оси
   по спецификации обрезает и вторую: всплывающий над карточкой список там
   просто не виден. Поэтому на телефоне он не absolute у карточки, а fixed
   у экрана — нижней шторкой во всю его ширину. */
@media (max-width: 720px) {
  .menu {
    position: fixed;
    inset: auto var(--sp-4) var(--sp-4) var(--sp-4);
    /* Выше всплывашки проверки цен (prices/PriceRefreshButton.module.css): на
       телефоне обе прижаты к этому же углу теми же отступами, а при равном
       слое порядок решал бы DOM — и наверху мог оказаться не тот. Шторку
       выбирают пальцем, сообщение только читают, поэтому шторка сверху. */
    z-index: 1110;
    max-height: 50vh;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-modal);
  }

  /* Пункты выбираются пальцем — строка списка не может быть в один текст. */
  .item {
    min-height: 44px;
    font-size: var(--fs-md);
  }
}
